import type { CallbackInterface } from "recoil";

import type { SelectFiltersState } from "./model";

import { filtersState } from "./state";

import { fetchFilters } from "./service";

export const fetchFiltersCallback =
  ({ set, snapshot }: CallbackInterface) =>
  async () => {
    const { status } = await snapshot.getPromise(filtersState);

    if (status === "ready") return;

    set<SelectFiltersState>(filtersState, (prev) => ({
      ...prev,
      status: "initial",
      loading: true,
    }));

    try {
      const { options, optionsGroups } = await fetchFilters();

      set<SelectFiltersState>(filtersState, (prev) => ({
        ...prev,
        options,
        optionsGroups,
        status: "ready",
      }));
    } catch (error) {
      console.error("### error", error);

      set<SelectFiltersState>(filtersState, (prev) => ({
        ...prev,
        status: "error",
      }));
    }

    set(filtersState, (prev) => ({ ...prev, loading: false }));
  };
